import { render, staticRenderFns } from "./creata-or-edit-data-item-detail.vue?vue&type=template&id=d7c2ad50&scoped=true"
import script from "./creata-or-edit-data-item-detail.vue?vue&type=script&lang=js"
export * from "./creata-or-edit-data-item-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c2ad50",
  null
  
)

export default component.exports